import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Charge } from '../_models/charge.model';

@Injectable()
export class ChargeService {
  constructor(private http: HttpClient) {}

  getAllCharges(): Observable<Charge[]> {
    return this.http.get<Charge[]>('api/charges/');
  }

  createCharges(charges: Array<Charge>): Observable<Charge[]> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<any>(
      'api/charges/add_set/',
      { set: charges },
      { headers: httpHeaders }
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }
}
